var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-info-gradient",style:([_vm.colorObject])},[_c('div',{staticClass:"c-info-mix-background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }